import { ButtonERP, Dialog } from "@finanedi.es/storybook"
import { useTranslation } from "react-i18next"
import { CreateEditEntidadModalProps } from "../.."
import { BankSelector } from "./Components/BankSelector/BankSelector"
import { MandateSelector } from "./Components/MandateSelector/MandateSelector"
import { PrincipalSwitch } from "./Components/PrincipalSwitch/PrincipalSwitch"
import { useCuentaBancariasForm } from "./UseCuentaBancariasForm"

interface ModalAccountContactCuentaBancariaProps {
  id: string
  createOrEditModal?: CreateEditEntidadModalProps
  onHide: () => void
  contactosCuentaBancariaByIdRefetch: () => void
}

export const ModalAccountContactCuentaBancaria = ({
  id,
  createOrEditModal,
  onHide,
  contactosCuentaBancariaByIdRefetch,
}: ModalAccountContactCuentaBancariaProps) => {
  const {
    control,
    register,
    handleSubmit,
    watch,
    setValue,
    onSubmit,
    clearErrors,
    errors,
    resetForm,
  } = useCuentaBancariasForm({
    id,
    createOrEditModal,
    contactosCuentaBancariaByIdRefetch,
    onHide,
  })
  const { t } = useTranslation()

  return (
    <Dialog
      visible={createOrEditModal?.show}
      className='tw-rounded-lg tw-bg-white !tw-w-130'
      baseZIndex={50}
      closable
      resizable={false}
      keepInViewport={false}
      headerClassName='[&>:first-child]:!tw-text-lg'
      header={t(
        createOrEditModal?.isEdit
          ? "contactos.cuentasBancarias.editCuentaTitle"
          : "contactos.cuentasBancarias.newCuentaTitle"
      )}
      footer={false}
      onHide={() => {
        onHide()
        resetForm()
      }}
    >
      <form
        onSubmit={handleSubmit(onSubmit)}
        key={createOrEditModal?.isEdit?.id ?? "new"}
      >
        <section className='tw-flex tw-flex-col tw-gap-4'>
          <BankSelector
            register={register}
            setValue={setValue}
            control={control}
            watch={watch}
            errors={errors}
            clearErrors={clearErrors}
          />
          <MandateSelector
            register={register}
            control={control}
            errors={errors}
          />
          <PrincipalSwitch control={control} />
          <div className='tw-w-full tw-flex tw-flex-row tw-justify-end tw-gap-4'>
            <ButtonERP
              customize={{
                size: "md",
                type: "transparent",
              }}
              onClick={() => {
                onHide()
                resetForm()
              }}
              type='button'
              label={`${t("contactos.cuentasBancarias.cancelButton")}`}
            />
            <ButtonERP
              customize={{
                size: "md",
                type: createOrEditModal?.isEdit ? "primary" : "secondary",
              }}
              type='button'
              onClick={handleSubmit(onSubmit)}
              label={`${t(
                createOrEditModal?.isEdit
                  ? "contactos.cuentasBancarias.edit"
                  : "contactos.cuentasBancarias.addAccount"
              )}`}
            />
          </div>
        </section>
      </form>
    </Dialog>
  )
}
